import { getConfig } from '../config/index.js';
export function getGlobalBasePath() {
    const { basePath } = getConfig();
    return basePath !== null && basePath !== void 0 ? basePath : '';
}
